/*----------------------
      STICKY TEXT 
---------------------- */

swiperStickyText = {
    init: function () {
        new Swiper('.swiper--sticky-text', {
            slidesPerView: "auto",
            mousewheel: {
                invert: false,
                forceToAxis: true
            },
        });
    }
};


$(function () {
    swiperStickyText.init();
});